import baseCtls from './baseCtls/index';
import dataCtls from './dataCtls/index';
import fileCtls from './fileCtls/index';
import dateCtls from './dateCtls/index';
import busCtls from './busCtls/index';
import mesCtls from './mesCtls/index';

export default {
  ...mesCtls,
  ...busCtls,
  ...dateCtls,
  ...fileCtls,
  ...dataCtls,
  ...baseCtls,
}
